import times from 'lodash/times';
import React from 'react';
import { EVENT_TYPE, LoadingCards } from '../LoadingCards';
import styles from './LoadingBucket.module.scss';

const LoadingBucket: React.FC = () =>
    times(4, (index) => (
        <div className={styles.root} key={`loading-card-${index}`}>
            <div className={styles.cardList}>
                {index === 0 ? (
                    <LoadingCards type={EVENT_TYPE} style="grid" cardCount={1} />
                ) : (
                    <LoadingCards type={EVENT_TYPE} style="list-square" cardCount={1} />
                )}
            </div>
            <div className={styles.card}>
                <LoadingCards type={EVENT_TYPE} style="grid" cardCount={1} />
            </div>
        </div>
    ));

export default LoadingBucket;
